import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styledComponent from '../../utils/styledComponent';

const Label = styledComponent('span', {
  padding: '8px 16px',
  borderRadius: '14px',
  fontWeight: 'bold',
  cursor: 'default',
  '&.secondary': {
    fontWeight: 'normal',
    padding: '2px 8px',
    borderRadius: '4px',
  },
  '&.small': {
    fontSize: '10px',
    padding: '2px 8px',
  },
  '&.gray': {
    background: '#e6e6e6',
  },
  '&.lightGray': {
    background: '#f2f2f2',
  },
  '&.green': {
    background: '#A5DC7E',
  },
  '&.lightGreen': {
    background: '#cae8b8',
  },
  '&.yellow': {
    background: '#ffbe6b',
  },
  '&.lightYellow': {
    background: '#fdd191',
  },
  '&.red': {
    background: '#ff6a6a',
  },
  '&.lightRed': {
    background: '#ffb9b9',
  },
  '&.blue': {
    background: '#6fa8dc',
  },
  '&.lightBlue': {
    background: '#bce4ff',
  },
});

const TextLabel = ({ text, color, small, tooltip, type = '' }) => {
  if (tooltip && !small) {
    // render Label with tooltip
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-top-${text.replace(/\s+/g, '-')}`}>
            {tooltip}
          </Tooltip>
        }
      >
        <Label
          className={`${color} ${small ? 'small' : ''} ${type ? type : ''}`}
        >
          {text}
        </Label>
      </OverlayTrigger>
    );
  } else {
    return (
      <Label className={`${color} ${small ? 'small' : ''} ${type ? type : ''}`}>
        {text}
      </Label>
    );
  }
};

export default TextLabel;
